// import * as React from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Card,
//   TextField,
//   IconButton,
//   Stack,
//   Tooltip,
//   Typography,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Grid,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Visibility as ViewIcon,
//   CheckCircle as AcceptIcon,
//   Cancel as RejectIcon,
//   Pending as PendingIcon,
//   Delete as DeleteIcon,
//   Email as EmailIcon,
//   Download as DownloadIcon,
// } from "@mui/icons-material";
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import { gridSpacing } from "store/constant";
// import MainCard from "ui-component/cards/MainCard";
// import { useDebounce } from "hooks/useDebounced";

// export default function MaterialEntryExit() {
//   const navigate = useNavigate();
//   const [page, setPage] = useState(0);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);
//   const [updatingStatus, setUpdatingStatus] = useState({});
//   const [downloading, setDownloading] = useState({});

//   const debouncedSearch = useDebounce(search, 1000);

//   // ✅ Fetch Material Permits
//   const fetchMaterialPermits = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams({
//         page: page + 1,
//         limit: rowsPerPage,
//         search,
//         status: statusFilter,
//       });

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}material-permit-list?${queryParams}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();
//       if (result.code === 200) {
//         setRows(result.data.materialPermits || []);
//         setTotal(result.data.pagination?.total || 0);
//       } else {
//         toast.error(result.message || "Failed to fetch material permits");
//         setRows([]);
//         setTotal(0);
//       }
//     } catch (error) {
//       console.error("Error fetching material permits:", error);
//       toast.error("Something went wrong while fetching material permits");
//       setRows([]);
//       setTotal(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchMaterialPermits();
//   }, [page, rowsPerPage, debouncedSearch, statusFilter]);

//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const handleStatusFilter = (event) => {
//     setStatusFilter(event.target.value);
//     setPage(0);
//   };

//   // ✅ Update material permit status
//   const updateMaterialPermitStatus = async (id, newStatus, name) => {
//     if (updatingStatus[id]) return;
//     const actionText = newStatus === "accept" ? "Accept" : "Reject";

//     swal({
//       title: `${actionText} ${name}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this material permit?`,
//       icon: newStatus === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: newStatus === "reject",
//     }).then(async (willProceed) => {
//       if (!willProceed) return;

//       try {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}update-material-permit-status/${id}`,
//           {
//             method: "PUT",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ status: newStatus }),
//           }
//         );

//         const result = await response.json();
//         if (result.code === 200) {
//           toast.success(`Material permit ${actionText}ed successfully`);
//           setRows((prev) =>
//             prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item))
//           );
//         } else {
//           toast.error(result.message || `Failed to ${actionText.toLowerCase()} material permit`);
//         }
//       } catch (error) {
//         console.error("Error updating material permit status:", error);
//         toast.error("Something went wrong while updating status");
//       } finally {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
//       }
//     });
//   };

//   // ✅ Send material gate pass
//   const sendGatePass = async (id, name) => {
//     setSendingPass(true);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}send-material-gate-pass/${id}`,
//         {
//           method: "POST",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       const result = await response.json();

//       if (result.code === 200) {
//         toast.success(`Material gate pass sent successfully to ${name}`);
//       } else {
//         toast.error(result.message || "Failed to send gate pass");
//       }
//     } catch (error) {
//       console.error("Error sending material gate pass:", error);
//       toast.error("Something went wrong while sending gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   const handleDownload = async (id, driverName) => {
//     if (downloading[id]) return;

//     setDownloading((prev) => ({ ...prev, [id]: true }));

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/download-gatepass-material/${id}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Download failed:", errorText);
//         toast.error("Failed to download gate pass");
//         return;
//       }

//       // ✅ Check if response has content
//       const contentType = response.headers.get("content-type");
//       if (!contentType || !contentType.includes("application/pdf")) {
//         console.error("Invalid content type:", contentType);
//         toast.error("Invalid PDF response");
//         return;
//       }

//       const blob = await response.blob();

//       // ✅ Verify blob has content
//       if (blob.size === 0) {
//         console.error("Empty PDF received");
//         toast.error("Empty PDF file");
//         return;
//       }

//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `GatePass_${driverName}.pdf`;
//       document.body.appendChild(a);
//       a.click();

//       // ✅ Cleanup after a short delay
//       setTimeout(() => {
//         window.URL.revokeObjectURL(url);
//         document.body.removeChild(a);
//         toast.success("Gate pass downloaded successfully");
//       }, 100);
//     } catch (error) {
//       console.error("Error downloading gate pass:", error);
//       toast.error("Something went wrong while downloading gate pass");
//     } finally {
//       setDownloading((prev) => ({ ...prev, [id]: false }));
//     }
//   };

//   // ✅ Delete material permit
//   const deleteMaterialPermit = (id, name) => {
//     swal({
//       title: `Delete ${name}?`,
//       text: "This will permanently delete this material permit record!",
//       icon: "warning",
//       buttons: ["Cancel", "Delete"],
//       dangerMode: true,
//     }).then(async (willDelete) => {
//       if (!willDelete) return;

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}delete-material-permit/${id}`,
//           {
//             method: "DELETE",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );
//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success("Material permit deleted successfully");
//           setRows((prev) => prev.filter((item) => item._id !== id));
//           setTotal((prev) => prev - 1);
//         } else {
//           toast.error(result.message || "Failed to delete material permit");
//         }
//       } catch (error) {
//         console.error("Error deleting material permit:", error);
//         toast.error("Something went wrong while deleting material permit");
//       }
//     });
//   };

//   // ✅ Status chip display
//   const getStatusChip = (status) => {
//     const statusConfig = {
//       pending: { color: "warning", icon: <PendingIcon />, label: "Pending" },
//       accept: { color: "success", icon: <AcceptIcon />, label: "Accepted" },
//       reject: { color: "error", icon: <RejectIcon />, label: "Rejected" },
//     };
//     const config = statusConfig[status] || statusConfig.pending;

//     return (
//       <Chip
//         icon={config.icon}
//         label={config.label}
//         color={config.color}
//         size="small"
//         variant="outlined"
//       />
//     );
//   };

//   const formatDate = (dateString) =>
//     new Date(dateString).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });

//   return (
//     <>
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Search material permits..."
//             type="search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Material name, requester, ID..."
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <FormControl fullWidth>
//             <InputLabel>Status Filter</InputLabel>
//             <Select value={statusFilter} onChange={handleStatusFilter} label="Status Filter">
//               <MenuItem value="all">All Status</MenuItem>
//               <MenuItem value="pending">Pending</MenuItem>
//               <MenuItem value="accept">Accepted</MenuItem>
//               <MenuItem value="reject">Rejected</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       <MainCard
//         title={
//           <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
//             <Grid item>
//               <Typography variant="h3">Material Entry & Exit Permits ({total} total)</Typography>
//             </Grid>
//           </Grid>
//         }
//         content={false}
//       >
//         <Card>
//           <Paper sx={{ width: "100%", overflow: "hidden" }}>
//             <TableContainer sx={{ maxHeight: 600 }}>
//               <Table stickyHeader aria-label="material permit table">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>S. No.</TableCell>
//                     <TableCell>company Name</TableCell>
//                     <TableCell>Department</TableCell>
//                     <TableCell>Driver Name</TableCell>
//                     <TableCell>Contact</TableCell>
//                     <TableCell>HOD Status</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell align="center">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {loading ? (
//                     <TableRow>
//                       <TableCell colSpan={8} align="center">
//                         <Typography>Loading...</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : rows.length === 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={8} align="center">
//                         <Typography>No material permits found</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     rows.map((row, index) => (
//                       <TableRow hover key={row._id}>
//                         <TableCell>{page * rowsPerPage + index + 1}</TableCell>
//                         <TableCell>
//                           <Typography fontWeight="bold">{row.companyName}</Typography>
//                         </TableCell>
//                         <TableCell>{row.department}</TableCell>
//                         <TableCell>{row.driverName}</TableCell>
//                         <TableCell>{row.email || "N/A"}</TableCell>
//                         <TableCell>{getStatusChip(row.staff_status)}</TableCell>
//                         <TableCell>{getStatusChip(row.status)}</TableCell>
//                         <TableCell align="center">
//                           <Stack direction="row" spacing={0.5} justifyContent="center">
//                             <Tooltip title="View Details">
//                               <IconButton
//                                 size="small"
//                                 color="info"
//                                 onClick={() => navigate(`/material-permit/${row._id}`)}
//                               >
//                                 <ViewIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>

//                             {row.status === "pending" && (
//                               <>
//                                 <Tooltip title="Accept">
//                                   <IconButton
//                                     size="small"
//                                     color="success"
//                                     onClick={() =>
//                                       updateMaterialPermitStatus(row._id, "accept", row.driverName)
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     {updatingStatus[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <AcceptIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>

//                                 <Tooltip title="Reject">
//                                   <IconButton
//                                     size="small"
//                                     color="error"
//                                     onClick={() =>
//                                       updateMaterialPermitStatus(row._id, "reject", row.driverName)
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     <RejectIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}

//                             {row.status === "accept" && (
//                               <>
//                                 <Tooltip title="Send Gate Pass">
//                                   <IconButton
//                                     size="small"
//                                     color="primary"
//                                     onClick={() => sendGatePass(row._id, row.driverName)}
//                                     disabled={sendingPass}
//                                   >
//                                     <EmailIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Download Gate Pass">
//                                   <IconButton
//                                     size="small"
//                                     color="secondary"
//                                     onClick={() => handleDownload(row._id, row.driverName)}
//                                     disabled={!!downloading[row._id]}
//                                   >
//                                     {downloading[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <DownloadIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}

//                             <Tooltip title="Delete">
//                               <IconButton
//                                 size="small"
//                                 color="error"
//                                 onClick={() => deleteMaterialPermit(row._id, row.driverName)}
//                               >
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                           </Stack>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <TablePagination
//               rowsPerPageOptions={[5, 10, 25, 50]}
//               component="div"
//               count={total}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//             />
//           </Paper>
//         </Card>
//       </MainCard>
//     </>
//   );
// }

import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  TextField,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  CircularProgress,
} from "@mui/material";
import {
  Visibility as ViewIcon,
  CheckCircle as AcceptIcon,
  Cancel as RejectIcon,
  Pending as PendingIcon,
  Delete as DeleteIcon,
  Email as EmailIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { gridSpacing, PASS_STATUS } from "store/constant";
import MainCard from "ui-component/cards/MainCard";
import { useDebounce } from "hooks/useDebounced";
import { useTranslation } from "react-i18next";

export default function MaterialEntryExit() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sendingPass, setSendingPass] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState({});
  const [downloading, setDownloading] = useState({});

  const debouncedSearch = useDebounce(search, 1000);

  // Fetch Material Permits
  const fetchMaterialPermits = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        search,
        status: statusFilter,
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}material-permit-list?${queryParams}`,
        {
          method: "GET",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      const result = await response.json();
      if (result.code === 200) {
        setRows(result.data.materialPermits || []);
        setTotal(result.data.pagination?.total || 0);
      } else {
        toast.error(result.message || t("MaterialEntryExit.fetchFailed"));
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching material permits:", error);
      toast.error(t("MaterialEntryExit.somethingWentWrong"));
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMaterialPermits();
  }, [page, rowsPerPage, debouncedSearch, statusFilter]);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStatusFilter = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };

  // Update material permit status
  // const updateMaterialPermitStatus = async (id, newStatus, name) => {
  //   if (updatingStatus[id]) return;
  //   const actionText =
  //     newStatus === "accept" ? t("MaterialEntryExit.accept") : t("MaterialEntryExit.reject");

  //   swal({
  //     title: `${actionText} ${name}?`,
  //     text: t("MaterialEntryExit.confirmStatusChange", {
  //       action: actionText.toLowerCase(),
  //     }),
  //     icon: newStatus === "accept" ? "success" : "error",
  //     buttons: [t("MaterialEntryExit.cancel"), actionText],
  //     dangerMode: newStatus === "reject",
  //   }).then(async (willProceed) => {
  //     if (!willProceed) return;

  //     try {
  //       setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}update-material-permit-status/${id}`,
  //         {
  //           method: "PUT",
  //           headers: {
  //             authkey: process.env.REACT_APP_AUTH_KEY,
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ status: newStatus, lang: localStorage.getItem("lang") }),
  //         },
  //       );

  //       const result = await response.json();
  //       if (result.code === 200) {
  //         toast.success(t("MaterialEntryExit.statusUpdated", { action: actionText }));
  //         setRows((prev) =>
  //           prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item)),
  //         );
  //       } else {
  //         toast.error(
  //           result.message || t("MaterialEntryExit.statusUpdateFailed", { action: actionText }),
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error updating material permit status:", error);
  //       toast.error(t("MaterialEntryExit.somethingWentWrong"));
  //     } finally {
  //       setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
  //     }
  //   });
  // };

  // Send material gate pass
  // const sendGatePass = async (id, name) => {
  //   setSendingPass(true);
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_API_URL}send-material-gate-pass/${id}`,
  //       {
  //         method: "POST",
  //         headers: {
  //           authkey: process.env.REACT_APP_AUTH_KEY,
  //           Authorization: `Bearer ${localStorage.getItem("token")}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ lang: localStorage.getItem("lang") }),
  //       }
  //     );
  //     const result = await response.json();

  //     if (result.code === 200) {
  //       toast.success(t("MaterialEntryExit.gatePassSent", { name }));
  //     } else {
  //       toast.error(result.message || t("MaterialEntryExit.gatePassSendFailed"));
  //     }
  //   } catch (error) {
  //     console.error("Error sending material gate pass:", error);
  //     toast.error(t("MaterialEntryExit.somethingWentWrong"));
  //   } finally {
  //     setSendingPass(false);
  //   }
  // };

  const updateMaterialPermitStatus = async (id, newStatus, name) => {
    if (updatingStatus[id]) return;

    // STEP 1: Language selection
    const langChoice = await swal({
      title: t("MaterialEntryExit.chooseLanguageTitle"),
      text: t("MaterialEntryExit.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    const actionText =
      newStatus === "accept" ? t("MaterialEntryExit.accept") : t("MaterialEntryExit.reject");

    // STEP 2: Confirmation
    const willProceed = await swal({
      title: `${actionText} ${name}?`,
      text: t("MaterialEntryExit.confirmStatusChange", {
        action: actionText.toLowerCase(),
      }),
      icon: newStatus === "accept" ? "success" : "error",
      buttons: [t("MaterialEntryExit.cancel"), actionText],
      dangerMode: newStatus === "reject",
    });

    if (!willProceed) return;

    try {
      setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}update-material-permit-status/${id}`,
        {
          method: "PUT",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: newStatus,
            lang: langChoice, // ✅ explicit language
          }),
        },
      );

      const result = await response.json();

      if (result.code === 200) {
        toast.success(t("MaterialEntryExit.statusUpdated", { action: actionText }));

        setRows((prev) =>
          prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item)),
        );
      } else {
        toast.error(
          result.message ||
            t("MaterialEntryExit.statusUpdateFailed", {
              action: actionText,
            }),
        );
      }
    } catch (error) {
      console.error("Error updating material permit status:", error);
      toast.error(t("MaterialEntryExit.somethingWentWrong"));
    } finally {
      setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
    }
  };

  const sendGatePass = async (id, name) => {
    const langChoice = await swal({
      title: t("MaterialEntryExit.chooseLanguageTitle"),
      text: t("MaterialEntryExit.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    setSendingPass(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}send-material-gate-pass/${id}`,
        {
          method: "POST",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ lang: langChoice }),
        },
      );

      const result = await response.json();
      if (result.code === 200) {
        toast.success(t("MaterialEntryExit.gatePassSent", { name }));
      } else {
        toast.error(result.message || t("MaterialEntryExit.gatePassSendFailed"));
      }
    } catch (error) {
      console.error("Error sending material gate pass:", error);
      toast.error(t("MaterialEntryExit.somethingWentWrong"));
    } finally {
      setSendingPass(false);
    }
  };

  const handleDownload = async (id, driverName) => {
    const choice = await swal({
      title: t("MaterialEntryExit.downloadOptions.title"),
      text: t("MaterialEntryExit.downloadOptions.text"),
      icon: "info",
      buttons: {
        gatepass: {
          text: t("MaterialEntryExit.downloadOptions.gatePass"),
          value: "gatepass",
        },
        details: {
          text: t("MaterialEntryExit.downloadOptions.details"),
          value: "details",
        },
      },
    });

    if (!choice) return;
    if (downloading[id]) return;

    setDownloading((prev) => ({ ...prev, [id]: true }));

    try {
      let endpoint = "";
      let fileName = "";

      if (choice === "gatepass") {
        endpoint = `${process.env.REACT_APP_API_URL}download-gatepass-material/${id}`;
        fileName = `GatePass_${driverName}.pdf`;
      } else if (choice === "details") {
        endpoint = `${process.env.REACT_APP_API_URL}download-gatepass-material-details/${id}`;
        fileName = `MaterialGatePassDetails_${driverName}.pdf`;
      } else {
        return;
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: localStorage.getItem("lang") }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Download failed:", errorText);
        toast.error(t("MaterialEntryExit.gatePassDownloadFailed"));
        return;
      }

      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/pdf")) {
        console.error("Invalid content type:", contentType);
        toast.error(t("MaterialEntryExit.invalidPDF"));
        return;
      }

      const blob = await response.blob();
      if (blob.size === 0) {
        console.error("Empty PDF received");
        toast.error(t("MaterialEntryExit.emptyPDF"));
        return;
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        toast.success(t("MaterialEntryExit.gatePassDownloaded"));
      }, 100);
    } catch (error) {
      console.error("Error downloading gate pass:", error);
      toast.error(t("MaterialEntryExit.somethingWentWrong"));
    } finally {
      setDownloading((prev) => ({ ...prev, [id]: false }));
    }
  };

  // Delete material permit
  const deleteMaterialPermit = (id, name) => {
    swal({
      title: t("MaterialEntryExit.deleteConfirm", { name }),
      text: t("MaterialEntryExit.deleteWarning"),
      icon: "warning",
      buttons: [t("MaterialEntryExit.cancel"), t("MaterialEntryExit.delete")],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}delete-material-permit/${id}`,
          {
            method: "DELETE",
            headers: {
              authkey: process.env.REACT_APP_AUTH_KEY,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        const result = await response.json();

        if (result.code === 200) {
          toast.success(t("MaterialEntryExit.materialDeleted"));
          setRows((prev) => prev.filter((item) => item._id !== id));
          setTotal((prev) => prev - 1);
        } else {
          toast.error(result.message || t("MaterialEntryExit.materialDeleteFailed"));
        }
      } catch (error) {
        console.error("Error deleting material permit:", error);
        toast.error(t("MaterialEntryExit.somethingWentWrong"));
      }
    });
  };

  // Status chip display
  const getStatusChip = (status) => {
    const statusConfig = {
      pending: {
        color: "warning",
        icon: <PendingIcon />,
        label: t("MaterialEntryExit.pending"),
      },
      accept: {
        color: "success",
        icon: <AcceptIcon />,
        label: t("MaterialEntryExit.accepted"),
      },
      reject: {
        color: "error",
        icon: <RejectIcon />,
        label: t("MaterialEntryExit.rejected"),
      },
    };
    const config = statusConfig[status] || statusConfig.pending;

    return (
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        size="small"
        variant="outlined"
      />
    );
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label={t("MaterialEntryExit.search")}
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={t("MaterialEntryExit.searchPlaceholder")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>{t("MaterialEntryExit.statusFilter")}</InputLabel>
            <Select
              value={statusFilter}
              onChange={handleStatusFilter}
              label={t("MaterialEntryExit.statusFilter")}
            >
              <MenuItem value="all">{t("MaterialEntryExit.allStatus")}</MenuItem>
              <MenuItem value="pending">{t("MaterialEntryExit.pending")}</MenuItem>
              <MenuItem value="accept">{t("MaterialEntryExit.accepted")}</MenuItem>
              <MenuItem value="reject">{t("MaterialEntryExit.rejected")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <MainCard
        title={
          <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
            <Grid item>
              <Typography variant="h3">
                {t("MaterialEntryExit.materialPermitsTitle", { total })}
              </Typography>
            </Grid>
          </Grid>
        }
        content={false}
      >
        <Card>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="material permit table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("MaterialEntryExit.sNo")}</TableCell>
                    <TableCell>{t("MaterialEntryExit.companyName")}</TableCell>
                    <TableCell>{t("MaterialEntryExit.department")}</TableCell>
                    <TableCell>{t("MaterialEntryExit.driverName")}</TableCell>
                    <TableCell>{t("MaterialEntryExit.contact")}</TableCell>
                    <TableCell align="center">{t("MaterialEntryExit.type")}</TableCell>
                    <TableCell>{t("MaterialEntryExit.hodStatus")}</TableCell>
                    <TableCell>{t("MaterialEntryExit.status")}</TableCell>
                    <TableCell align="center">{t("MaterialEntryExit.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <Typography>{t("MaterialEntryExit.loading")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={8} align="center">
                        <Typography>{t("MaterialEntryExit.noMaterialPermits")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row, index) => (
                      <TableRow hover key={row._id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>
                          <Typography fontWeight="bold">{row.companyName}</Typography>
                        </TableCell>
                        <TableCell>{row.department.name}</TableCell>
                        <TableCell>{row.driverName}</TableCell>
                        <TableCell>{row.email || "N/A"}</TableCell>
                        <TableCell align="center">{row.formType || "N/A"}</TableCell>
                        <TableCell>{getStatusChip(row.staff_status)}</TableCell>
                        <TableCell>{getStatusChip(row.status)}</TableCell>
                        <TableCell align="center">
                          <Stack direction="row" spacing={0.5} justifyContent="center">
                            <Tooltip title={t("MaterialEntryExit.viewDetails")}>
                              <IconButton
                                size="small"
                                color="info"
                                onClick={() => navigate(`/material-permit/${row._id}`)}
                              >
                                <ViewIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>

                            {row.staff_status !== PASS_STATUS.REJECTED &&
                              row.status === PASS_STATUS.PENDING && (
                                <>
                                  <Tooltip title={t("MaterialEntryExit.accept")}>
                                    <IconButton
                                      size="small"
                                      color="success"
                                      onClick={() =>
                                        updateMaterialPermitStatus(
                                          row._id,
                                          "accept",
                                          row.driverName || "Visitor",
                                        )
                                      }
                                      disabled={!!updatingStatus[row._id]}
                                    >
                                      {updatingStatus[row._id] ? (
                                        <CircularProgress size={16} />
                                      ) : (
                                        <AcceptIcon fontSize="small" />
                                      )}
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title={t("MaterialEntryExit.reject")}>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() =>
                                        updateMaterialPermitStatus(
                                          row._id,
                                          "reject",
                                          row.driverName || "Visitor",
                                        )
                                      }
                                      disabled={!!updatingStatus[row._id]}
                                    >
                                      <RejectIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                            {row.status === "accept" && (
                              <>
                                <Tooltip title={t("MaterialEntryExit.sendGatePass")}>
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() => sendGatePass(row._id, row.driverName)}
                                    disabled={sendingPass}
                                  >
                                    <EmailIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={t("MaterialEntryExit.downloadGatePass")}>
                                  <IconButton
                                    size="small"
                                    color="secondary"
                                    onClick={() => handleDownload(row._id, row.driverName)}
                                    disabled={!!downloading[row._id]}
                                  >
                                    {downloading[row._id] ? (
                                      <CircularProgress size={16} />
                                    ) : (
                                      <DownloadIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}

                            <Tooltip title={t("MaterialEntryExit.delete")}>
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => deleteMaterialPermit(row._id, row.driverName)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Card>
      </MainCard>
    </>
  );
}
